import React, { useEffect, useState } from "react";
import "../../pages/viewUser/viewUser.css";
import { FaPause, FaPlay } from "react-icons/fa6";
import { useParams } from "react-router-dom";

const ViewAnswer = () => {
  const [startAudio, setStartAudio] = useState(false);
  const [viewAnswer, setViewAnswer] = useState({});
  const params = useParams();

  const getAnswer = async () => {
    try {
      if (params.id) {
        const response = null;
        if (response) {
          setViewAnswer(response);
          console.log(response);
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    getAnswer();
  }, []);

  return (
    <div className="container mb-5">
      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
          <ion-icon name="eye-outline"></ion-icon>
          <span className="text">View Answer</span>
        </div>
      </div>

      <div className="mt-4">
        <div className="userInfo mt-4">
          <label>Number of family member</label>
          <div>{viewAnswer.familyMemberNumber}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Thumbnail</label>
          <div className="viewStory mt-2">
          </div>
        </div>
        <div className="userInfo mt-4">
          <label>Name</label>
          <div>{viewAnswer.name}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Number of recorded number</label>
          <div>{viewAnswer.familyMemberNumber}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Recording</label>
          <div>{viewAnswer.recordingName}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Location</label>
          <div>{viewAnswer.location?.map((item) => ` ${item} ,`)}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Name of family member</label>
          <div>{viewAnswer.nameOfFamilyMember}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Media</label>
          <div className="d-flex justify-content-lg-start mt-2">
            <div className="recordingMicIcon">
              {startAudio ? (
                <FaPause
                  onClick={() => {
                    setStartAudio(false);
                  }}
                  className="pauseIconFont"
                />
              ) : (
                <FaPlay
                  onClick={() => {
                    setStartAudio(true);
                  }}
                  className="playIconFont"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAnswer;
